module.exports = "/images/discover-5.png";